(() => {
  const root = document.getElementById('dof-compact');
  if (!root) return;
  const el = id => root.querySelector('#dc-' + id);
  const fields = ['f', 'n', 'p', 'c', 'u', 'n2', 'time', 'adapter'];
  const outputs = [...root.querySelectorAll('dd')];
  const number = value => Number(value.toPrecision(7)).toString();
  const distance = value => value === Infinity ? 'Infinity' : number(value) + ' mm';
  const set = (id, text) => { el(id).textContent = text; };
  function limits(f, n, c, u) {
    const k = f * f / (n * c);
    const h = k + f;
    const near = u * k / (k + u - f);
    const far = u >= h ? Infinity : u * k / (k - u + f);
    return { h, near, far, total: far - near };
  }
  function calculate() {
    const values = {};
    let invalid = false;
    for (const name of fields) {
      const input = el(name);
      const value = Number(input.value);
      const bad = !input.value.trim() || !Number.isFinite(value) || value <= 0;
      input.setAttribute('aria-invalid', String(bad));
      invalid ||= bad;
      values[name] = value;
    }
    const { f, n, p, c: pixels, u, n2, time, adapter } = values;
    if (invalid || u <= f || u <= f * adapter) {
      for (const output of outputs) output.textContent = '--';
      if (!invalid) el('u').setAttribute('aria-invalid', 'true');
      el('error').textContent = invalid
        ? 'Enter a positive number in every field.'
        : 'Object distance must exceed both the original and adapted focal lengths.';
      return;
    }
    el('error').textContent = '';
    const c = pixels * p / 1000;
    const base = limits(f, n, c, u);
    const adapted = limits(f * adapter, n, c, u);
    for (const name of ['near', 'far', 'total', 'h']) set(name, distance(base[name]));
    set('defocus', number(f * f / (u - f)) + ' mm');
    set('hdefocus', number(f * f / (u - f) - n * c) + ' mm');
    set('focus', number(2 * n * u / (u - f) * c * 1000) + ' µm');
    set('mtf', number(0.687048826 / (0.000650 * n)) + ' lp/mm');
    set('mono', number(500 / p) + ' cycles/mm');
    set('green', number(1000 / (2 * Math.SQRT2 * p)) + ' cycles/mm');
    set('rb', number(250 / p) + ' cycles/mm');
    set('light', number((n / n2) ** 2) + '×');
    set('time2', number(time * (n2 / n) ** 2) + ' s');
    for (const name of ['near', 'far', 'total']) set('adapter-' + name, distance(adapted[name]));
    set('adapter-change', base.total === Infinity && adapted.total === Infinity
      ? 'Undefined when both ranges extend to infinity'
      : adapted.total === Infinity ? 'Increases to infinity'
      : base.total === Infinity ? 'Becomes finite'
      : distance(adapted.total - base.total));
  }
  root.addEventListener('input', calculate);
  root.addEventListener('change', calculate);
  calculate();
})();
